'use client'

import { Suspense } from 'react'
import { useRouter } from 'next/navigation'
import { useAuthState } from '@view/auth/lib'
import { authFormStore, type AuthTab } from '@view/auth/model'
import { observer } from 'mobx-react-lite'

import { CredentialsForm } from './credentials-form'
import { EmailVerification } from './email-verification'

interface AuthFormProps {
  tab: AuthTab
}

const tabRoutes: Record<AuthTab, string> = {
  login: '/auth/login',
  register: '/auth/register',
}

export const AuthForm = observer(({ tab }: AuthFormProps) => {
  const router = useRouter()
  const { state, redirectPage } = useAuthState(tab)

  const goToTab = (target: AuthTab) => {
    if (target !== tab) {
      const query = new URLSearchParams(window.location.search)
      router.replace(`${tabRoutes[target]}${query.size ? `?${query.toString()}` : ''}`)
    }
  }

  if (tab === 'register' && authFormStore.isVerifying) {
    return (
      <Suspense>
        <EmailVerification redirectPage={redirectPage} />
      </Suspense>
    )
  }

  return (
    <Suspense>
      <CredentialsForm tab={tab} state={state} redirectPage={redirectPage} onSwitchTab={goToTab} />
    </Suspense>
  )
})
